import { Route } from '@angular/router';
import { Permission } from '../../models/permission.model';
import { PermissionGuard } from '../../shared/guards/permission.guard';

export const onboardingRoute: Route = {
  path: 'onboarding',
  canActivate: [PermissionGuard],
  data: {
    permissions: [Permission.PORTFOLIO_ASSISTANT, Permission.PORTFOLIO_MANAGER, Permission.CLIENT],
  },
  children: [
    {
      path: ':id',
      loadComponent: () => import('./onboarding.component').then((c) => c.OnboardingComponent),
    },
  ],
};

export const managerOnboardingRoute: Route = {
  path: 'manager/onboarding',
  canActivate: [PermissionGuard],
  data: {
    permissions: [Permission.PORTFOLIO_ASSISTANT, Permission.PORTFOLIO_MANAGER],
  },
  // canDeactivate: [UnsavedChangesGuard],
  children: [
    {
      path: ':id',
      loadComponent: () => import('./onboarding.component').then((c) => c.OnboardingComponent),
    },
    {
      path: 'view/:id',
      loadComponent: () => import('./onboarding.component').then((c) => c.OnboardingComponent),
    },
  ],
};
